import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {
  CalendarTypesEnum,
  ChangeCalendarFocusedDayMethodsEnum,
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../services/tracking';
import {
  shiftCalendarViewAction,
  updateCalendarFocusedDateAction,
} from '../../store/panels/calendars/calendarsPanelActions';
import {makeGetCalendarsParameters} from '../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarViewShiftDirectionsEnum} from '../../store/panels/calendars/calendarsPanelState';
import {CalendarsPanelId} from '../../store/panels/panelStateBase';
import {SideCalendarsControls} from './sideCalendarsControls';

/*
 * Props.
 */

interface SideCalendarsControlsContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Selectors.
 */

function makeGetFocusedDate() {
  return createSelector([makeGetCalendarsParameters()], (parameters) => parameters.focusedDate);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SideCalendarsControlsContainerProps>()(() => ({
  focusedDate: makeGetFocusedDate(),
}));

const mapDispatchToProps = makeMapDispatchToProps<SideCalendarsControlsContainerProps>()(({panelId}) => ({
  onFocusedDateSelect: (focusedDate: number) => {
    trackInterfaceEvent(InterfaceEventsEnum.CHANGE_CALENDAR_FOCUSED_DAY, {
      method: ChangeCalendarFocusedDayMethodsEnum.DAY_PICKER,
      calendar_type: CalendarTypesEnum.SIDE,
    });

    return updateCalendarFocusedDateAction(panelId, focusedDate);
  },
  onTodayButtonClick: () => {
    trackInterfaceEvent(InterfaceEventsEnum.CHANGE_CALENDAR_FOCUSED_DAY, {
      method: ChangeCalendarFocusedDayMethodsEnum.TODAY_BUTTON,
      calendar_type: CalendarTypesEnum.SIDE,
    });

    return updateCalendarFocusedDateAction(panelId, Date.now());
  },
  onCalendarShiftClick: (direction: CalendarViewShiftDirectionsEnum) => {
    trackInterfaceEvent(InterfaceEventsEnum.CHANGE_CALENDAR_FOCUSED_DAY, {
      method:
        direction === CalendarViewShiftDirectionsEnum.PREVIOUS
          ? ChangeCalendarFocusedDayMethodsEnum.PREVIOUS_BUTTON
          : ChangeCalendarFocusedDayMethodsEnum.NEXT_BUTTON,
      calendar_type: CalendarTypesEnum.SIDE,
    });

    return shiftCalendarViewAction(panelId, direction);
  },
}));

export const SideCalendarsControlsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideCalendarsControls);
